import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { OverridableComponent } from '@mui/material/OverridableComponent';

import Home from '@mui/icons-material/Home';
import BarChartIcon from '@mui/icons-material/BarChart';
import PersonIcon from '@mui/icons-material/Person';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InfoIcon from '@mui/icons-material/Info';
import GroupIcon from '@mui/icons-material/Group';
import LogoutIcon from '@mui/icons-material/Logout';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import HubIcon from '@mui/icons-material/Hub';
import ChatIcon from '@mui/icons-material/Chat';

import OilIcon from './icons/OilIcon';
import FryingIcon from './icons/FyingIcon';
import CocoLightIcon from './components/customIcons/CocoLightIcon';

import { getWhatsAppUrl } from './utils/utils';
import {
  GENERAL_ADMINS,
  NON_ENTREPOSTO_VIEWS,
  Permission,
  CAN_REVIEW_FLOCOS,
  ENTREPOSTO_VIEWS,
  GROUP_VIEWS,
} from './constants/Permission';
import SeedsSackIcon from './icons/SeedsSackIcon';
import CerealIcon from './icons/CerealIcon';

export type PageConfigType =
  | 'singlePage'
  | 'hasListFormDetail'
  | 'hasFormDetail'
  | 'editOnly'
  | 'createOnly'
  | 'externalUrl';

interface PageConfig {
  title: string;
  Icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  home?: boolean;
  skipRouter?: boolean;
  skipMenu?: boolean;
  skipTopBar?: boolean;
  type: PageConfigType;
  permission?: Permission[] | null;
  subPages?: Record<string, Omit<PageConfig, 'home' | 'skipRouter' | 'subPages'>>;
  externalUrl?: string | ((isMobile: boolean) => string);
  onClick?: () => void;
  dividerUp?: boolean;
}

interface PagesConfig {
  [key: string]: PageConfig;
}

const PAGES: PagesConfig = {
  home: {
    title: 'Início',
    Icon: Home,
    skipRouter: true,
    type: 'singlePage',
  },
  azeite_production: {
    title: 'Produção de azeite',
    Icon: FryingIcon,
    type: 'hasListFormDetail',
    permission: NON_ENTREPOSTO_VIEWS,
  },
  oleo_production: {
    title: 'Produção de óleo',
    Icon: OilIcon,
    type: 'hasListFormDetail',
    permission: NON_ENTREPOSTO_VIEWS,
  },
  flocos_production: {
    title: 'Produção de Flocos',
    Icon: SeedsSackIcon,
    type: 'hasListFormDetail',
  },
  mesocarpo_processing: {
    title: 'Beneficiamento',
    Icon: CerealIcon,
    type: 'hasListFormDetail',
    permission: [...ENTREPOSTO_VIEWS, ...GENERAL_ADMINS],
  },
  flocos_review: {
    title: 'Revisão dos Flocos',
    Icon: CocoLightIcon,
    type: 'hasFormDetail',
    skipMenu: true,
    permission: CAN_REVIEW_FLOCOS,
  },
  relatorios: {
    title: 'Relatórios',
    Icon: BarChartIcon,
    type: 'singlePage',
    permission: [...GROUP_VIEWS, ...GENERAL_ADMINS],
  },
  perfil: {
    title: 'Seu perfil',
    Icon: PersonIcon,
    type: 'hasFormDetail',
    dividerUp: true,
  },
  minha_senha: {
    title: 'Sua senha',
    type: 'editOnly',
    skipMenu: true,
  },
  entreposto: {
    title: 'Dados do entreposto',
    Icon: WarehouseIcon,
    type: 'hasFormDetail',
    permission: [Permission.COORDENADORA_ENTREPOSTO],
  },
  gerenciar_usuarias: {
    title: 'Gerenciar usuárias',
    Icon: GroupIcon,
    type: 'hasListFormDetail',
    permission: GENERAL_ADMINS,
  },
  gerenciar_entrepostos: {
    title: 'Gerenciar entrepostos',
    Icon: HubIcon,
    type: 'hasListFormDetail',
    permission: GENERAL_ADMINS,
  },
  signup: {
    title: 'Criar usuária',
    type: 'createOnly',
    permission: GENERAL_ADMINS,
    skipMenu: true,
  },
  change_password: {
    title: 'Trocar senha de usuária',
    type: 'editOnly',
    permission: GENERAL_ADMINS,
    skipMenu: true,
  },
  ajuda: {
    title: 'Ajuda',
    Icon: WhatsAppIcon,
    type: 'externalUrl',
    externalUrl: (isMobile: boolean) => {
      return getWhatsAppUrl({ isMobile });
    },
    skipMenu: true,
  },
  contato: {
    title: 'Contatos',
    type: 'singlePage',
    Icon: ChatIcon,
    dividerUp: true,
  },
  sobre: {
    title: 'Sobre',
    type: 'singlePage',
    Icon: InfoIcon,
  },
  signout: {
    title: 'Sair',
    Icon: LogoutIcon,
    type: 'singlePage',
    skipMenu: true,
  },
};

export default PAGES;
